import { Link } from 'react-router'

function Footer() {
  return (
    <footer className="bg-muted py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="space-y-4">
            <h3 className="font-bold text-lg">TytoBio</h3>
            <p className="text-muted-foreground text-sm">
              Your platform for recording, tracking, and sharing biological observations with your community.
            </p>
          </div>

          <div>
            <h4 className="font-medium mb-4">Account</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/login" className="text-muted-foreground hover:text-foreground">Log in</Link></li>
              <li><Link to="/register" className="text-muted-foreground hover:text-foreground">Sign up</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy-policy" className="text-muted-foreground hover:text-foreground">Privacy</Link></li>
              <li><Link to="/terms-of-service" className="text-muted-foreground hover:text-foreground">Terms</Link></li>
              <li><Link to="/cookies-policy" className="text-muted-foreground hover:text-foreground">Cookies</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-8 pt-8 text-center">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} TytoBio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
